export const SET_ADMIN_STATE = 'SET_ADMIN_STATE';



// WEBPACK FOOTER //
// ./src/admin/CONSTANTS.js